// react_frontend/src/Context/SupportContext.js
import React, { createContext, useState } from "react";

export const SupportContext = createContext();

export const SupportProvider = ({ children }) => {
  const [showSupport, setShowSupport] = useState(false);

  return (
    <SupportContext.Provider value={{ showSupport, setShowSupport }}>
      {children}
    </SupportContext.Provider>
  );
};